import { render } from "./MyAdvertisements.vue?vue&type=template&id=1a0d74b2"
import script from "./MyAdvertisements.vue?vue&type=script&lang=js"
export * from "./MyAdvertisements.vue?vue&type=script&lang=js"

import "./MyAdvertisements.vue?vue&type=style&index=0&id=1a0d74b2&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__